export default __webpack_public_path__ + "static/media/ccoc_2021_logo_desktop.86f1f200.svg";